<template>
  <div>
    <!-- Activity form -->
    <Dialog
      v-if="!contactFormDialog && !customerFormDialog"
      :visible.sync="activityForm1"
      :style="{ width: '750px', overflowY: 'auto' }"
      :header="taskMode ? 'Task Details' : 'Event Details'"
      :modal="true"
      class="p-fluid"
      @keyup="keyMonitor"
    >
      <template #header>
        <h5>{{ taskMode ? "Task Details" : "Event Details" }}</h5>

        <span
          :key="statusKey"
          :class="'ignore pointer badge ' + getStyle(activityStatus)"
          v-on:click="changeStatus(activity)"
        >
          {{ activityStatus ? activityStatus.statusName : "" }}
        </span>

        <OverlayPanel
          ref="statuses"
          appendTo="body"
          :showCloseIcon="true"
          id="statuses"
          style="width: 130px"
        >
          <div v-for="(val, index) in tempActivityStatuses" :key="index">
            <span
              @click="showProgressLostWarning(val)"
              :class="'ignore pointer badge ' + getStyle(val)"
            >
              {{ val.statusName }}
            </span>
            <br />
            <br />
          </div>
        </OverlayPanel>

        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </template>

      <h5 class="center">{{ taskMode ? "Main Task Info" : "Main Event Info" }}</h5>
      <br />
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="Subject">Subject *</label>
          <InputText
            id="subject"
            v-model="activity.subject"
            required="true"
            autofocus
            :class="{ 'p-invalid': activitySubmitted && !activity.subject }"
            :disabled="disabledArr.includes('subject')"
          />
          <small class="p-invalid" v-if="activitySubmitted && !activity.subject"
            >{{ taskMode ? "Task" : "Event" }} Subject is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="user">Created For</label>
          <!-- <Dropdown
            v-model="user"
            :options="users"
            optionLabel="fullName"
            placeholder="Select user"
            dataKey="id"
            :showClear="true"
            id="user"
            :disabled="disabledArr.includes('user')"
          /> -->
          <CustomDropDown
            :allOptions="users"
            :disabled="disabledArr.includes('user')"
            :dataKey="fullName"
            :index="fullName"
            :currentValue="user"
            v-model="user"
            :optionLabel="['fullName']"
            placeholder="Type to display options"
            style="width: 100%"
            @selected="setSelection"
          >
          </CustomDropDown>
        </div>
        <div class="p-field p-col">
          <label for="activityDate">{{ taskMode ? "Task" : "Event" }} Date*</label>
          <Calendar
            id="dateCreated"
            v-model="activity.dateCreated"
            dateFormat="dd/mm/yy"
            :showIcon="true"
            :disabled="disabledArr.includes('dateCreated')"
            :class="{ 'p-invalid': activitySubmitted && !activity.dateCreated }"
          />
          <small
            class="p-invalid"
            v-if="activitySubmitted && !activity.dateCreated"
            >{{ taskMode ? "Task" : "Event" }} Date is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="activityType">{{ taskMode ? "Type" : "Event Type" }}</label>
          <Dropdown
            v-model="activityType"
            :options="typeOptions"
            optionLabel="activityTypeName"
            dataKey="id"
            placeholder="Select Type"
            :showClear="true"
            id="activityType"
            :disabled="disabledArr.includes('activityType')"
          />
        </div>
        <div class="p-field p-col">
          <label for="mbpBranch">MBP Branch</label>
          <Dropdown
            :key="reloadDropdown"
            v-model="mbpBranch"
            :options="mbpBranches"
            optionLabel="branchName"
            datakey="id"
            placeholder="Select MBP Branch"
            :showClear="true"
            id="id"
            :disabled="disabledArr.includes('mbpBranch')"
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="customer">Customer</label>
          <div class="p-inputgroup">
            <InputText
              class="clearer"
              placeholder="Click button to search for customer"
              :disabled="true"
              v-model="selectedCustomer.custName"
            >
            </InputText>
            <Button
              icon="pi pi-search"
              class="p-button-warning"
              @click="() => (custSearchDialog = true)"
              :disabled="disabledArr.includes('customer')"
            />
          </div>
        </div>
        <div class="p-field p-col">
          <label for="contact"
            >Contact<span
              v-if="activityType && activityType.activityTypeName === 'Meeting'"
            >
              *</span
            ></label
          >
          <Dropdown
            vif="selectedCustomer.custName"
            v-model="activity.contact"
            :options="contacts"
            optionLabel="contactName"
            dataKey="contactId"
            placeholder="Select Contact"
            :showClear="true"
            id="contact"
            :disabled="disabledArr.includes('contact')"
            :class="{
              'p-invalid':
                activitySubmitted &&
                activityType &&
                activityType.activityTypeName === 'Meeting' &&
                !activity.contact
            }"
          />
          <small
            class="p-invalid"
            v-if="
              activitySubmitted &&
                activityType &&
                activityType.activityTypeName === 'Meeting' &&
                !activity.contact
            "
            >Contact is required for Meetings.</small
          >
          <InputText
            v-else-if="activity.contact"
            class="clearer"
            v-model="activity.contact.contactName"
            :disabled="true"
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="quote">Quotation</label>
          <div class="p-inputgroup">
            <InputText
              class="clearer"
              placeholder="Click button to search for quotation"
              :disabled="true"
              v-model="quotation.visible"
            >
            </InputText>
            <Button
              icon="pi pi-search"
              class="p-button-warning"
              @click="quotationSelectionDialog = true"
              :disabled="disabledArr.includes('quotation')"
            />
          </div>
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="notes">Notes</label>
          <Textarea
            v-model.trim="activity.notes"
            :autoResize="true"
            :rows="getRowSize()"
            required="false"
            autofocus
            id="notes"
            :disabled="disabledArr.includes('notes')"
          />
        </div>
      </div>
      <br />

      <h5 class="center">{{ taskMode ? "When" : "Event Timing" }}</h5>
      <br />

      <!-- <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <ToggleButton v-model="activityTimingSection" onLabel="Show event timing section" offLabel="Hide event timing section" onIcon="pi pi-file" offIcon="pi pi-times" />
        </div>
      </div> -->

      <div class="p-formgrid p-grid" v-if="!activityTimingSection">
        <div class="p-field p-col">
          <label for="startDate">{{ taskMode ? "When*" : "Start Date*" }}</label>
          <!-- <InputMask 
            mask="99/99/9999" 
            v-model="startDate" 
            slotChar="dd/mm/yyyy" 
            id="startDate"
            :disabled="disabledArr.includes('startDate') || activityType.activityTypeName === 'Task'"
            required="true"
            autofocus
            :class="{ 'p-invalid': this.activitySubmitted && this.activityType && this.activityType.activityTypeName !== 'Task' && !this.activity.startDate }"
          /> -->
          <Calendar
            id="startDate"
            v-model="startDate"
            dateFormat="dd/mm/yy"
            :showIcon="true"
            :disabled="
              disabledArr.includes('startDate') ||
                undatedTaskType
            "
            required="true"
            autofocus
            :class="{
              'p-invalid':
                this.activitySubmitted &&
                this.startRequired &&
                !this.activity.startDate
            }"
          />
          <small class="p-invalid" v-if="showStartDateError"
            >Start Date and Time must be in the future.</small
          >
          <br />
          <small
            class="p-invalid"
            v-if="
              this.activitySubmitted &&
                this.startRequired &&
                !this.activity.startDate
            "
            >{{ taskMode ? "When is required." : "Start Date is required." }}</small
          >
        </div>
        <div class="p-field p-col">
          <label for="startTime">{{ taskMode ? "Time*" : "Start Time*" }}</label>
          <Calendar
            id="startTime"
            v-model="startTime"
            :showIcon="true"
            :showTime="true"
            :timeOnly="true"
            hourFormat="24"
            :disabled="
              disabledArr.includes('startTime') ||
                undatedTaskType
            "
            required="true"
            autofocus
            :class="{
              'p-invalid':
                this.activitySubmitted &&
                this.startRequired &&
                !this.activity.startTime
            }"
          />
          <small class="p-invalid" v-if="showStartDateError"
            >Start Date and Time must be in the future.</small
          >
          <br />
          <small
            class="p-invalid"
            v-if="
              this.activitySubmitted &&
                this.startRequired &&
                !this.activity.startTime
            "
            >{{ taskMode ? "Time is required." : "Start Time is required." }}</small
          >
        </div>
      </div>
      <!-- A task has a When and nothing else: no duration, no end. -->
      <div class="p-formgrid p-grid" v-if="!activityTimingSection && !taskMode">
        <div class="p-field p-col">
          <label for="endDate">Duration in minutes</label>
          <InputNumber
            id="duration"
            v-model="duration"
            required="false"
            :disabled="
              disabledArr.includes('duration') ||
                activityType.activityTypeName === 'Task'
            "
            :class="{
              'p-invalid':
                activitySubmitted &&
                activity.startTime &&
                activity.startDate &&
                !activity.duration
            }"
          />
          <small
            class="p-invalid"
            v-if="
              activitySubmitted &&
                activityType &&
                activityType.activityTypeName !== 'Task' &&
                activity.startTime &&
                activity.startDate &&
                !activity.duration
            "
            >Duration is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="endDate">End Date*</label>
          <Calendar
            id="endDate"
            v-model="endDate"
            dateFormat="dd/mm/yy"
            :showIcon="true"
            :disabled="
              disabledArr.includes('endDate') ||
                activityType.activityTypeName === 'Task'
            "
            :class="{
              'p-invalid':
                this.activitySubmitted &&
                this.activityType &&
                this.activityType.activityTypeName === 'Meeting' &&
                !this.activity.endDate
            }"
          />
          <small
            class="p-invalid"
            v-if="
              this.activitySubmitted &&
                this.activityType &&
                this.activityType.activityTypeName === 'Meeting' &&
                !this.activity.endDate
            "
            >End Date is required for a Meeting.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="endTime">End Time*</label>
          <Calendar
            id="endTime"
            v-model="activity.endTime"
            :showIcon="true"
            :showTime="true"
            :timeOnly="true"
            hourFormat="24"
            :disabled="
              disabledArr.includes('endTime') ||
                activityType.activityTypeName === 'Task'
            "
            :class="{
              'p-invalid':
                this.activitySubmitted &&
                this.activityType &&
                this.activityType.activityTypeName === 'Meeting' &&
                !this.activity.endTime
            }"
          />
          <small
            class="p-invalid"
            v-if="
              this.activitySubmitted &&
                this.activityType &&
                this.activityType.activityTypeName === 'Meeting' &&
                !this.activity.endTime
            "
            >End Time is required for a Meeting.</small
          >
        </div>
      </div>
      <br />

      <h5 class="center">{{ taskMode ? "Task" : "Event" }} Reminder</h5>
      <br />

      <!-- <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <ToggleButton v-model="activityReminderSection" onLabel="Show reminder section" offLabel="Hide reminder section" onIcon="pi pi-file" offIcon="pi pi-times" />
        </div>
      </div> -->

      <!-- <div class="p-formgrid p-grid" v-if="!activityReminderSection">
        <div class="p-field p-col">
          <label for="deadlineDate">Deadline Date*</label>
          <Calendar
            id="deadlineDate"
            v-model="deadlineDate"
            dateFormat="dd/mm/yy"
            :showIcon="true"
            :disabled="disabledArr.includes('deadlineDate')"
          />
        </div>
        <div class="p-field p-col">
          <label for="deadlineTime">Deadline Time*</label>
          <Calendar
            id="deadlineTime"
            v-model="activity.deadlineTime"
            :showIcon="true"
            :showTime="true"
            :timeOnly="true"
            hourFormat="24"
            :disabled="disabledArr.includes('deadlineTime')"
          />
        </div>
      </div> -->
      <div class="p-formgrid p-grid" v-if="!activityReminderSection">
        <div class="p-field p-col">
          <label for="reminder">Create Reminder?</label>
          <SelectButton
            v-model="reminder"
            :options="options1"
            optionLabel="name"
            id="reminder"
            :disabled="disabledArr.includes('reminder')"
          />
        </div>
        <div class="p-field p-col">
          <label for="activity.reminderType">Reminder Type</label>
          <Dropdown
            id="reminderType"
            v-model="reminderType"
            :options="remindertypes"
            dataKey="id"
            optionLabel="reminderTypeName"
            placeholder="Select Reminder Type"
            :showClear="true"
            :disabled="
              disabledArr.includes('reminderType') ||
                !(reminder && reminder.value)
            "
            :class="{
              'p-invalid':
                this.activitySubmitted &&
                this.activity &&
                !this.activity.reminderType &&
                this.reminder && this.reminder.value
            }"
          />
          <small
            class="p-invalid"
            v-if="
              this.activitySubmitted &&
                this.activity &&
                !this.activity.reminderType &&
                this.reminder && this.reminder.value
            "
            >Reminder Type is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid" v-if="!activityReminderSection">
        <div class="p-field p-col">
          <label for="reminderDate">Reminder Date*</label>
          <Calendar
            id="reminderDate"
            v-model="reminderDate"
            dateFormat="dd/mm/yy"
            :showIcon="true"
            :disabled="
              disabledArr.includes('reminderDate') ||
                !(reminder && reminder.value)
            "
            :class="{
              'p-invalid':
                this.activitySubmitted &&
                this.activity &&
                !this.activity.reminderDate &&
                this.reminder && this.reminder.value
            }"
          />
          <small class="p-invalid" v-if="showReminderDateError"
            >Reminder Date and Time should be in the future.</small
          >
          <br />
          <small
            class="p-invalid"
            v-if="
              this.activitySubmitted &&
                this.activity &&
                !this.activity.reminderDate &&
                this.reminder && this.reminder.value
            "
            >Reminder Date is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="reminderTime">Reminder Time*</label>
          <Calendar
            id="reminderTime"
            v-model="reminderTime"
            :showIcon="true"
            :showTime="true"
            :timeOnly="true"
            hourFormat="24"
            :disabled="
              disabledArr.includes('reminderTime') ||
                !(reminder && reminder.value)
            "
            :class="{
              'p-invalid':
                this.activitySubmitted &&
                this.activity &&
                !this.activity.reminderTime &&
                this.reminder && this.reminder.value
            }"
          />
          <small class="p-invalid" v-if="showReminderDateError"
            >Reminder Date and Time should be in the future.</small
          >
          <br />
          <small
            class="p-invalid"
            v-if="
              this.activitySubmitted &&
                this.activity &&
                !this.activity.reminderTime &&
                this.reminder && this.reminder.value
            "
            >Reminder Time is required.</small
          >
        </div>
      </div>

      <template #footer v-if="!disabledArr.includes('buttons')">
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-danger"
          @click="hideDialog"
          style="width: 100px"
        />
        <ProgressSpinner
          v-if="sendingRequest"
          style="width:25px; height:25px; width: 100px;"
          strokeWidth="5"
          fill="#EEEEEE"
          animationDuration=".5s"
        />
        <Button
          v-else
          label="Save"
          icon="pi pi-check"
          class="p-button-success"
          @click="saveActivity"
          style="width: 100px"
        />
      </template>
    </Dialog>

    <!-- Contact form -->
    <Dialog
      v-else-if="contactFormDialog && !customerFormDialog"
      :visible.sync="contactFormDialog"
      :style="{ width: '900px', overflowY: 'auto' }"
      header="Contact details"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="firstName">First Name*</label>
          <InputText
            id="firstName"
            v-model="contact.firstName"
            required="false"
            :class="{ 'p-invalid': contactSubmitted && !contact.firstName }"
            :disabled="disabledArr.includes('firstName')"
            style="text-transform: uppercase"
          />
          <small class="p-invalid" v-if="contactSubmitted && !contact.firstName"
            >First Name is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="lastName">Surname*</label>
          <InputText
            id="lastName"
            v-model="contact.lastName"
            required="false"
            :class="{ 'p-invalid': contactSubmitted && !contact.lastName }"
            :disabled="disabledArr.includes('lastName')"
            style="text-transform: uppercase"
          />
          <small class="p-invalid" v-if="contactSubmitted && !contact.lastName"
            >Last Name is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="jobFunction">Job Function*</label>
          <Dropdown
            id="jobFunction"
            :showClear="true"
            v-model="contact.jobFunction"
            :options="jobFunctions"
            optionLabel="jobFuncName"
            placeholder="Select Job Function"
            :disabled="disabledArr.includes('jobFunction')"
            :class="{ 'p-invalid': contactSubmitted && !contact.jobFunction }"
          />
          <small
            class="p-invalid"
            v-if="contactSubmitted && !contact.jobFunction"
            >Job Function is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col p-col-8">
          <label for="jobTitle">Select Customer</label>
          <InputText
            id="customer"
            placeholder="Customer Name"
            :disabled="true"
            v-model="customer.custName"
          >
          </InputText>
        </div>
        <div class="p-field p-col p-col-4">
          <label for="jobTitle">Job Title</label>
          <InputText
            autofocus
            id="contactJobTitle"
            placeholder="Write a Job Title"
            :disabled="disabledArr.includes('contactJobTitle')"
            v-model="contact.contactJobTitle"
          >
          </InputText>
          <!-- <Dropdown
            v-model="contact.jobTitle"
            :options="jobTitles"
            optionLabel="jobTitleDesc"
            placeholder="Select Job Title"
            :showClear="true"
            id="jobTitle"
            :disabled="disabledArr.includes('jobTitle')"
            :class="{ 'p-invalid': contactSubmitted && !contact.jobTitle }"
          />
          <small
            class="p-invalid"
            v-if="contactSubmitted && !contact.jobTitle"
            >Job Title is required.</small
          > -->
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="address1">House</label>
          <InputText
            id="address1"
            v-model="contact.address1"
            required="false"
            :disabled="disabledArr.includes('address1')"
            :class="{ 'p-invalid': contactSubmitted && !contact.address1 }"
            style="text-transform: uppercase"
          />
          <small class="p-invalid" v-if="contactSubmitted && !contact.address1"
            >House is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="address2">Street</label>
          <InputText
            id="address2"
            v-model="contact.address2"
            required="false"
            :disabled="disabledArr.includes('address2')"
            :class="{ 'p-invalid': contactSubmitted && !contact.address2 }"
            style="text-transform: uppercase"
          />
          <small class="p-invalid" v-if="contactSubmitted && !contact.address2"
            >Street is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="address3">Sub Area</label>
          <InputText
            id="address3"
            v-model="contact.address3"
            required="false"
            :disabled="disabledArr.includes('address3')"
            :class="{ 'p-invalid': contactSubmitted && !contact.address3 }"
            style="text-transform: uppercase"
          />
          <small class="p-invalid" v-if="contactSubmitted && !contact.address3"
            >Sub Area is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="address4">City/Town</label>
          <CustomDropDown
            :allOptions="citiesTowns"
            :disabled="false"
            optionLabel="cityTownName"
            dataKey="id"
            :forceSelection="true"
            :showDropDownOnStart="true"
            :currentValue="cityTown2"
            placeholder="Select City/Town"
            style="width: 100%"
            @selected="setSelection2"
            :inputClass="{ 'p-invalid': contactSubmitted && !contact.cityTown }"
          />
        </div>
        <div class="p-field p-col">
          <label for="postCode">Post Code</label>
          <InputText
            id="postCode"
            v-model="contact.postCode"
            required="false"
            :disabled="disabledArr.includes('postCode')"
            style="text-transform: uppercase"
          />
        </div>
        <!-- <div class="p-field p-col">
          <label for="country">Country</label>
          <InputText
            id="country"
            v-model="contact.country"
            required="false"
            
            :disabled="disabledArr.includes('country')"
          />
        </div> -->
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="phoneNo">Phone No</label>
          <InputText
            id="phoneNo"
            v-model="contact.phoneNo"
            required="false"
            :disabled="disabledArr.includes('phoneNo')"
          />
        </div>
        <div class="p-field p-col">
          <label for="mobile">Mobile</label>
          <InputText
            id="mobile"
            v-model.trim="contact.mobile"
            required="false"
            :disabled="disabledArr.includes('mobile')"
          />
        </div>
        <div class="p-field p-col">
          <label for="email">Email</label>
          <InputText
            id="email"
            v-model.trim="contact.email"
            required="false"
            :disabled="disabledArr.includes('email')"
            :class="{ 'p-invalid': contactSubmitted && !contact.email }"
          />
          <small class="p-invalid" v-if="contactSubmitted && !contact.email"
            >Email is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="notes">Notes</label>
          <InputText
            id="notes"
            v-model.trim="contact.notes"
            :disabled="disabledArr.includes('notes')"
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="canEmail">can Email?</label>
          <InputSwitch
            v-model="contact.canEmail"
            :disabled="disabledArr.includes('canEmail')"
          />
        </div>
        <div class="p-field p-col">
          <label for="canCall">can Call?</label>
          <InputSwitch
            v-model="contact.canCall"
            :disabled="disabledArr.includes('canCall')"
          />
        </div>
        <div class="p-field p-col">
          <label for="canMail">can Mail?</label>
          <InputSwitch
            v-model="contact.canMail"
            :disabled="disabledArr.includes('canMail')"
          />
        </div>
        <div class="p-field p-col">
          <label for="keyContact">Key Contact?</label>
          <InputSwitch
            v-model="contact.keyContact"
            :disabled="disabledArr.includes('keyContact')"
          />
        </div>
        <div class="p-field p-col">
          <label for="active">Active?</label>
          <InputSwitch
            v-model="contact.active"
            :disabled="disabledArr.includes('active')"
          />
        </div>
      </div>

      <template #footer>
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-danger"
          @click="hideAndOpenCustomer"
          style="width: 100px"
        />
        <ProgressSpinner
          v-if="sendingRequest"
          style="width:25px; height:25px; width: 100px;"
          strokeWidth="5"
          fill="#EEEEEE"
          animationDuration=".5s"
        />
        <Button
          v-else
          label="Save"
          icon="pi pi-check"
          class="p-button-success"
          @click="saveContact"
          style="width: 100px"
        />
      </template>
    </Dialog>

    <!-- Customer form -->
    <Dialog
      v-else-if="!contactFormDialog && customerFormDialog"
      :visible.sync="customerFormDialog"
      :style="{ width: '700px', overflowY: 'auto' }"
      header="Customer Details"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="custName">Customer Name *</label>
          <InputText
            id="custName"
            v-model="customer.custName"
            required="true"
            :class="{ 'p-invalid': customerSubmitted && !customer.custName }"
            @blur="checkForDuplicate"
            style="text-transform: uppercase"
          />
          <small
            class="p-invalid"
            v-if="customerSubmitted && !customer.custName"
            >Customer Name is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="address1">House</label>
          <InputText
            id="address1"
            v-model.trim="customer.address1"
            :class="{ 'p-invalid': customerSubmitted && !customer.address1 }"
            @blur="checkForDuplicate"
            style="text-transform: uppercase"
          />
          <small
            class="p-invalid"
            v-if="customerSubmitted && !customer.address1"
            >Address1 is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="address2">Street</label>
          <InputText
            id="address2"
            v-model="customer.address2"
            :class="{ 'p-invalid': customerSubmitted && !customer.address2 }"
            required="false"
            @blur="checkForDuplicate"
            style="text-transform: uppercase"
          />
          <small
            class="p-invalid"
            v-if="customerSubmitted && !customer.address2"
            >Address2 is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="address3">Sub Area</label>
          <InputText
            id="address3"
            v-model="customer.address3"
            :class="{ 'p-invalid': customerSubmitted && !customer.address3 }"
            required="false"
            autofocus
            @blur="checkForDuplicate"
            style="text-transform: uppercase"
          />
          <small
            class="p-invalid"
            v-if="customerSubmitted && !customer.address3"
            >Address3 is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="address4">City/Town</label>
          <CustomDropDown
            :allOptions="citiesTowns"
            :disabled="false"
            optionLabel="cityTownName"
            dataKey="id"
            :forceSelection="true"
            :showDropDownOnStart="true"
            :currentValue="cityTown1"
            placeholder="Select City/Town"
            style="width: 100%"
            @selected="setSelection1"
            :inputClass="{
              'p-invalid': customerSubmitted && !customer.cityTown
            }"
          />
          <small
            class="p-invalid"
            v-if="customerSubmitted && !customer.cityTown"
            >City/Town is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="postCode">Post Code</label>
          <InputText
            id="postCode"
            v-model="postCode"
            required="false"
            :class="{ 'p-invalid': customerSubmitted && !customer.postCode }"
            autofocus
            @blur="checkForDuplicate"
            style="text-transform: uppercase"
          />
          <small
            class="p-invalid"
            v-if="customerSubmitted && !customer.postCode"
            >Post Code is required.</small
          >
        </div>
      </div>

      <div class="p-formgrid p-grid">
        <div class="p-field p-col" v-if="duplicateChecking">
          <div class="errorMsg" style="background-color: dodgerblue;">
            <span class="errorSpan">
              Checking for duplicate customers...
            </span>
          </div>
        </div>
        <div
          class="p-field p-col"
          v-if="!duplicateChecking && duplicates.length"
        >
          <div class="errorMsg">
            <span class="errorSpan pr-5">
              Possible duplicate customers: {{ duplicates.length }}
            </span>
            <span
              class="errorSpan errorPointer pr-3"
              @click="displayDuplicateMessage = true"
            >
              View duplicates
            </span>
            <span
              class="errorSpan errorPointer"
              @click="checkForDuplicate()"
              v-if="
                lastEnteredName !== customer.custName ||
                  lastEnteredAddress1 !== customer.address1 ||
                  lastEnteredAddress2 !== customer.address2 ||
                  lastEnteredAddress3 !== customer.address3 ||
                  lastEnteredCityTown !==
                    (customer.cityTown && customer.cityTown.id) ||
                  lastEnteredPostCode !== customer.postCode
              "
            >
              Check again
            </span>
          </div>
        </div>
      </div>

      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="region">Region</label>
          <InputText
            v-if="customer.region"
            id="region"
            v-model="customer.region.regionName"
            :disabled="true"
            required="false"
          />
          <InputText v-else id="region" :disabled="true" required="false" />
        </div>
        <div class="p-field p-col">
          <label for="salesExec">Branch</label>
          <InputText
            id="branch"
            v-model="branch.branchName"
            :disabled="true"
            required="false"
            autofocus
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="salesExec">Sales Exec</label>
          <InputText
            id="salesExec"
            v-model="salesExec.salesExecName"
            :disabled="true"
            required="false"
            autofocus
          />
        </div>
        <div class="p-field p-col">
          <label for="customerType">Customer Type</label>
          <Dropdown
            id="customerType"
            v-model="customerType"
            :options="customertypes"
            optionLabel="typeName"
            placeholder="Select Customer Type"
            :class="{
              'p-invalid': customerSubmitted && !customer.customerType
            }"
            :showClear="true"
          />
          <small
            class="p-invalid"
            v-if="customerSubmitted && !customer.customerType"
            >Customer Type is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="phoneNo">Phone No</label>
          <InputText
            id="phoneNo"
            v-model="customer.phoneNo"
            :class="{ 'p-invalid': customerSubmitted && !customer.phoneNo }"
            required="false"
          />
          <small class="p-invalid" v-if="customerSubmitted && !customer.phoneNo"
            >Phone number is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="mobile">Email</label>
          <InputText
            id="mobile"
            v-model="customer.email"
            required="false"
            autofocus
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="mainNotes">Notes</label>
          <InputText
            id="mainNotes"
            v-model="customer.mainNotes"
            required="false"
          />
        </div>
      </div>
      <template #footer>
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-danger"
          @click="hideAndOpenCustomer"
          style="width: 100px"
        />
        <ProgressSpinner
          v-if="sendingRequest"
          style="width:25px; height:25px; width: 100px;"
          strokeWidth="5"
          fill="#EEEEEE"
          animationDuration=".5s"
        />
        <Button
          v-else
          label="Save"
          icon="pi pi-check"
          class="p-button-success"
          @click="saveCustomer"
          style="width: 100px"
        />
      </template>
    </Dialog>

    <CustomerSearchDialog
      :key="loadCustomersAgain"
      :custSearchDialog="custSearchDialog"
      :preSelectedCustomer="preSelectedCustomer"
      :isContactRequired="false"
      @close="custSearchDialog = false"
      @select="updateCustomer"
      @selectContact="selectContactForm"
      @selectCustomer="selectCustomerForm"
    />

    <QuotationSelection
      :key="quotationSelectionKey"
      :quotationSelectionDialog="quotationSelectionDialog"
      :quotations="quotes"
      :requestingQuotations="requestingQuotations"
      @close="quotationSelectionDialog = false"
      @selected="selectedQuotation"
    />

    <DuplicateDialog
      :key="duplicateDialogKey"
      :duplicateDialog="duplicateDialog"
      :contact="duplicateContact"
      @hide-duplicate-dialog="duplicateDialog = false"
      @submit-duplicate-form="sendDuplicateContact"
    />

    <!-- Customer duplicate message -->
    <Dialog header="Header" :visible.sync="customerDuplicateMessage">
      <template #header>
        <h3>Duplicate error</h3>
      </template>

      The following Customer seems to be a duplicate of some customers. Please
      confirm if you wish to still save this customer?

      <template #footer>
        <Button
          @click="customerDuplicateMessage = false"
          label="No"
          icon="pi pi-times"
          class="p-button-text"
        />
        <Button
          @click="sendDuplicateCustomer()"
          label="Yes"
          icon="pi pi-check"
          autofocus
        />
      </template>
    </Dialog>

    <ActivityMeetingDialog
      :meetingDialog="meetingDialog"
      :reload="reloadMeetingDialog"
      :activity="activity"
      :sendingRequest="sendingRequest"
      @close="meetingDialog = false"
      @save="saveMeetingDetails"
    />

    <ActivityRescheduleDialog
      :scheduleDialog="scheduleDialog"
      :reload="reloadScheduleDialog"
      :activity="activity"
      :sendingRequest="sendingRequest"
      :task="taskMode"
      @close="scheduleDialog = false"
      @save="saveScheduleDetails"
    />

    <CommentBox
      :reload="reloadCommentBox"
      :commentDialog="commentDialog"
      label="Please give details below"
      :sendingRequest="sendingRequest"
      @close="commentDialog = false"
      @save="addComment"
    />

    <!-- Progress lost warning message -->
    <Dialog header="Header" :visible.sync="progressLostWarning">
      <template #header>
        <h3>Progress lost warning</h3>
      </template>

      Any changes in the form will lost. Do you want to save the form first?

      <template #footer>
        <Button
          @click="updateStatus(tempStatus)"
          label="No"
          icon="pi pi-times"
          class="p-button-text"
        />
        <Button
          @click="saveAndUpdateStatus()"
          label="Yes"
          icon="pi pi-check"
          autofocus
        />
      </template>
    </Dialog>

    <duplicateTable
      v-if="displayDuplicateMessage"
      :duplicateDialog="displayDuplicateMessage"
      :dataId="'customerId'"
      :name="'Customer'"
      :namePlural="'Customers'"
      :list="duplicates"
      :disabledArr="['buttons']"
      @close="displayDuplicateMessage = false"
      @selected-customer="setCustomerSelection"
    />

    <!-- item (a), batch 3: an automatic follow-up email due around this task or event -->
    <FollowupDueWarning ref="followupDueWarning" :noun="taskMode ? 'task' : 'event'" />
  </div>
</template>

<script>
import { kindOfRecord } from "@/mbp/activityKind";
import { completionBody } from "@/mbp/activityFollowUp";
import CustomerService from "@/service/CustomerService";
import ActivityService from "@/service/ActivityService";
import UserService from "@/service/UserService";
import QuotationService from "@/service/QuotationService";

import CustomerSearchDialog from "../customer/CustomerSearchDialog";
import QuotationSelection from "../quotation/quotationSelection";
import DuplicateDialog from "../contact/duplicateDialog";
import ActivityMeetingDialog from "./ActivityMeetingDialog";
import ActivityRescheduleDialog from "./ActivityRescheduleDialog";
import CommentBox from "@/mbp/universalComponents/quotation/CommentBox";
import duplicateTable from "../customer/duplicateDialog";
import FollowupDueWarning from "@/mbp/followupWarning/FollowupDueWarning";
import { opensResultDialog, nextStatusesFor } from "../../activityCompletion.js";
import { typesForKind, effectiveModeFor } from "../../activityKind.js";
import { quoteLabel } from "./quoteLabel";

import {
  activityRequest,
  contactRequest,
  customerLessDataRequest,
  customerConf
} from "../sendRequest";

export default {
  components: {
    CustomerSearchDialog,
    QuotationSelection,
    DuplicateDialog,
    ActivityMeetingDialog,
    ActivityRescheduleDialog,
    CommentBox,
    duplicateTable,
    FollowupDueWarning
  },
  // mode: "task" for the Tasks screens (Call/Email/Task, a required "When", no
  // duration or end); "auto" for the screens that show tasks and activities together
  // (every type on offer, the rules of the selected type's kind); anything else,
  // including absent, is the Activities form.
  // The task form offers the types whose kind is TASK. allowedKind narrows the
  // Activities form to one kind (the Activities list's "New Activity" offers the
  // ACTIVITY types); absent, it offers every type. A record's own type stays on
  // offer even when it is not in the list (an inactive or other-kind type).
  props: ["activityToEdit", "disabledArr", "activityForm", "mode", "allowedKind"],
  data: () => ({
    customerService: new CustomerService(),
    activityService: new ActivityService(),
    userService: new UserService(),
    quotationService: new QuotationService(),
    custSearchDialog: false,
    activityTimingSection: false,
    activityReminderSection: false,
    contacts: [],
    users: [],
    quotes: [],
    mbpBranches: [],
    activitytypes: [],
    activitystatuses: [],
    tempActivityStatuses: [],
    tempActivityStatus: {},
    tempActivityType: {},
    mbpBranch: {},

    tempObj: {},
    meetingDialog: false,
    reloadMeetingDialog: 0,
    commentDialog: false,
    reloadCommentBox: 0,
    scheduleDialog: false,
    reloadScheduleDialog: 0,

    remindertypes: [],
    options1: [
      { name: "Yes", value: true },
      { name: "No", value: false }
    ],
    selectedCustomer: {},
    startDate: null,
    startTime: null,
    endDate: null,
    deadlineDate: null,
    reminderDate: null,
    reminderTime: null,
    reminderType: {},
    reminder: { name: "No", value: false },
    activity: {
      customer: {
        custName: ""
      },
      user: {
        fullName: ""
      },
      contact: {
        fullName: ""
      },
      supervisor: {
        fullName: ""
      }
    },
    user: {},
    quotationSelectionDialog: false,
    quotation: {},
    quotationSelectionKey: 0,
    activitySubmitted: false,
    contactSubmitted: false,
    customer: {},
    contact: {},
    // jobTitles: [],
    jobFunctions: [],
    citiesTowns: [],
    contactFormDialog: false,
    preSelectedCustomer: {},
    duplicateDialogKey1: 0,
    duplicateDialog: false,
    duplicateToSend: {},
    duplicateContact: {},
    customerFormDialog: false,
    duplicateCustCode: null,
    customerType: {},
    customertypes: [],
    customerSubmitted: false,
    customerDuplicateMessage: false,
    loadCustomersAgain1: 0,
    postCode: "",
    branch: {},
    salesExec: {},
    duration: null,
    statusKey1: 0,
    activityStatus: {},
    showStartDateError: false,
    showReminderDateError: false,
    activityType: {},
    sendingRequest: false,
    requestingQuotations: false,
    cityTown1: {},
    cityTown2: {},
    progressLostWarning: false,
    tempStatus: {},
    reloadDropdown1: 0,

    duplicates: [],
    duplicateChecking: false,
    lastEnteredName: "",
    lastEnteredPostCode: "",
    lastEnteredAddress1: "",
    lastEnteredAddress2: "",
    lastEnteredAddress3: "",
    lastEnteredCityTown: "",
    displayDuplicateMessage: false
  }),
  computed: {
    // The rules in force: "task" or "activity". In mode "auto" they follow the kind of
    // the type selected now, so changing the type changes the fields.
    effectiveMode() {
      return effectiveModeFor(this.mode, this.activityType);
    },
    taskMode() {
      return this.effectiveMode === "task";
    },
    // The types on offer follow the declared mode: "auto" offers every type.
    typeOptions() {
      const kind = this.mode === "task" ? "TASK" : this.allowedKind;
      const types = kind
        ? typesForKind(this.activitytypes, kind)
        : this.activitytypes;
      const own = this.activityToEdit && this.activityToEdit.activityType;
      return own && own.id && !types.some(t => t.id === own.id)
        ? [...types, own]
        : types;
    },
    // The Activities form keeps a new Task type undated: its start is disabled and
    // cleared. A record that already has a start keeps it (a dated task opened from an
    // activity screen), and the task form never does this.
    undatedTaskType() {
      return (
        !this.taskMode &&
        !!this.activityType &&
        this.activityType.activityTypeName === "Task" &&
        !(this.activityToEdit && this.activityToEdit.startDate)
      );
    },
    // The start is required for every task, and for every activity type but Task.
    startRequired() {
      return (
        !!this.activityType &&
        (this.taskMode || this.activityType.activityTypeName !== "Task")
      );
    },
    reloadDropdown: {
      set() {
        this.reloadDropdown1++;
      },
      get() {
        return "mbp-branch-dropdown-" + this.reloadDropdown1.toString();
      }
    },
    statusKey: {
      set() {
        this.statusKey1++;
      },
      get() {
        return "statusKey-" + this.statusKey1.toString();
      }
    },
    duplicateDialogKey: {
      set() {
        this.duplicateDialogKey1++;
      },
      get() {
        return "duplicateDialogKey-" + this.duplicateDialogKey1.toString();
      }
    },
    loadCustomersAgain: {
      set() {
        this.loadCustomersAgain1++;
      },
      get() {
        return "loadCustomersAgain-" + this.loadCustomersAgain1.toString();
      }
    },
    activityForm1: {
      set(val) {
        if (!val) {
          this.hideDialog();
        }
      },
      get() {
        return this.activityForm === true ? true : false;
      }
    }
  },
  created() {
    this.activity = {
      customer: {
        custName: ""
      },
      user: {
        fullName: ""
      },
      contact: {
        fullName: ""
      },
      supervisor: {
        fullName: ""
      }
    };

    if (this.activityToEdit && this.activityToEdit.activityId) {
      this.activity = { ...this.activityToEdit };

      if (this.activityToEdit.startDate) {
        let date = this.activityToEdit.startDate.split("/");
        this.startDate = new Date(date[2], date[1] - 1, date[0]);
      }

      if (this.activityToEdit.startTime) {
        let a = this.activityToEdit.startTime.split(":"),
          date1 = new Date(),
          year1 = date1.getFullYear(),
          month1 = date1.getMonth(),
          day1 = date1.getDate();
        this.startTime = new Date(year1, month1, day1, a[0], a[1]);
      }

      if (this.activityToEdit.reminderDate) {
        let date = this.activityToEdit.reminderDate.split("/");
        this.reminderDate = new Date(date[2], date[1] - 1, date[0]);
      }

      if (this.activityToEdit.reminderTime) {
        let a = this.activityToEdit.reminderTime.split(":"),
          date1 = new Date(),
          year1 = date1.getFullYear(),
          month1 = date1.getMonth(),
          day1 = date1.getDate();
        this.reminderTime = new Date(year1, month1, day1, a[0], a[1]);
      }

      this.endDate = this.activityToEdit.endDate;
      this.deadlineDate = this.activityToEdit.deadlineDate;
      this.reminderType = this.activityToEdit.reminderType;
      if (this.activityToEdit.reminder) {
        this.reminder = { name: "Yes", value: true };
      } else {
        this.reminder = { name: "No", value: false };
      }

      if (this.activityToEdit.duration) {
        this.duration = this.activityToEdit.duration;
      }
      if (this.activity.activityType) {
        this.activityType = this.activity.activityType;
      }

      if (this.activityToEdit.quote) {
        this.quotation = this.activityToEdit.quote;
        this.quotation.visible = quoteLabel(this.activityToEdit.quote);
      }

      if (this.activityToEdit.user) {
        this.user = this.activityToEdit.user;
      }

      if (this.activity.mbpBranch) {
        this.mbpBranch = {
          ...this.activity.mbpBranch,
          branchId: this.activity.mbpBranch.id
        };
      } else if (
        this.activity.mbpBranchId &&
        this.activity.mbpBranchName &&
        this.activity.mbpBranchCode
      ) {
        this.mbpBranch = {
          branchId: this.activity.mbpBranchId,
          branchName: this.activity.mbpBranchName,
          branchCode: this.activity.mbpBranchCode
        };
      }
    } else {
      this.activity.reminder = false;
      this.activity.user = this.$store.getters["auth/getMyProfile"];
      this.user = this.$store.getters["auth/getMyProfile"];
      if (this.user.defBranch) this.mbpBranch = this.user.defBranch;
      let a = new Date();
      this.activity.dateCreated = a;
    }

    if (
      this.activityToEdit.customer &&
      this.activityToEdit.customer.customerId
    ) {
      this.activity = { ...this.activityToEdit };
      this.selectedCustomer = this.activity.customer;

      this.customerService
        .getCustomerContacts(this.activityToEdit.customer.customerId)
        .then(data => (this.contacts = data))
        .catch(e => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting customers",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content:
              'Some data was not loaded from "customerContacts/{customerId}"'
          });
        });
    }

    this.customerService
      .getAllActiveMBPBranches()
      .then(data => {
        this.mbpBranches = data;
        if (this.activityToEdit) {
          if (this.activityToEdit.mbpBranchCode) {
            this.mbpBranch = this.mbpBranches.find(
              a => a.branchCode === this.activityToEdit.mbpBranchCode
            );
          } else if (this.activityToEdit.branchId) {
            this.mbpBranch = this.mbpBranches.find(
              a => a.id === this.activityToEdit.branchId
            );
          }
        }
        this.reloadDropdown1++;
      })
      .catch(e => {
        // this.$toast.add({
        //   severity: "error",
        //   summary: "Error",
        //   detail: "Error while getting branches",
        //   life: 5000,
        // })
        this.$store.dispatch("addErrorMessage", {
          severity: "error",
          content: 'Some data was not loaded from "activeMbpBranches"'
        });
      });
    this.activityService
      .getAllActiveActivityTypes()
      .then(data => {
        this.activitytypes = data;

        // A record opened from a list row carries a two-field type ({ id, activityTypeName });
        // select the full option instead, so the dropdown shows it and auto mode reads its kind.
        if (
          this.activityToEdit &&
          this.activityToEdit.activityId &&
          this.activityType &&
          this.activityType.id
        ) {
          const option = data.find(t => t.id === this.activityType.id);
          if (option) this.activityType = option;
        }

        if (
          (this.activity.activityStatus &&
            this.activity.activityStatus.statusName === "Task") ||
          !this.activity.activityStatus
        ) {
          let a = this.typeOptions.find(a => a.activityTypeName === "Task");
          // Where Task is not on offer, a new record starts on the first type that is.
          if (!a && (this.mode === "task" || this.allowedKind)) {
            a = this.typeOptions[0];
          }
          this.activityType = a;
        }
      })
      .catch(e => {
        // this.$toast.add({
        //   severity: "error",
        //   summary: "Error",
        //   detail: "Error while getting activity types",
        //   life: 5000,
        // })
        this.$store.dispatch("addErrorMessage", {
          severity: "error",
          content: 'Some data was not loaded from "activeActivityTypes"'
        });
      });

    this.activityService
      .getAllActivityStatuses()
      .then(data => {
        data.forEach(d => {
          if (!d.statusName) {
          }
        });
        this.activitystatuses = data.filter(d => d.statusName);
        this.setActivityStatus();
      })
      .catch(e => {
        // this.$toast.add({
        //   severity: "error",
        //   summary: "Error",
        //   detail: "Error while getting activity statuses",
        //   life: 5000,
        // })
        this.$store.dispatch("addErrorMessage", {
          severity: "error",
          content: 'Some data was not loaded from "activityStatuses"'
        });
      });
    this.activityService
      .getAllActiveReminderTypes()
      .then(data => (this.remindertypes = data))
      .catch(e => {
        // this.$toast.add({
        //   severity: "error",
        //   summary: "Error",
        //   detail: "Error while getting reminder types",
        //   life: 5000,
        // })
        this.$store.dispatch("addErrorMessage", {
          severity: "error",
          content: 'Some data was not loaded from "activeReminderTypes"'
        });
      });
    this.userService
      .getAllActiveUsers()
      .then(data => {
        this.users = data;
      })
      .catch(e => {
        // this.$toast.add({
        //   severity: "error",
        //   summary: "Error",
        //   detail: "Error while getting users",
        //   life: 5000,
        // })
        this.$store.dispatch("addErrorMessage", {
          severity: "error",
          content: 'Some data was not loaded from "activeUsers"'
        });
      });

    // this.customerService
    //   .getAllActiveJobTitles()
    //   .then((data) => (this.jobTitles = data))
    //   .catch(err => {
    //

    //     // this.$toast.add({
    //     //   severity: "error",
    //     //   summary: "Error",
    //     //   detail: "Error while getting job titles",
    //     //   life: 5000,
    //     // })
    //     this.$store.dispatch('addErrorMessage', {
    //       severity: 'error',
    //       content: 'Some data was not loaded from "activeJobTitles"'
    //     })
    //   })
    this.customerService
      .getAllJobFunctions()
      .then(data => (this.jobFunctions = data))
      .catch(err => {
        // this.$toast.add({
        //   severity: "error",
        //   summary: "Error",
        //   detail: "Error while getting jobFunctions",
        //   life: 5000,
        // })
        this.$store.dispatch("addErrorMessage", {
          severity: "error",
          content: 'Some data was not loaded from "jobFunctions"'
        });
      });
    this.customerService
      .getAllActiveCustomerTypes()
      .then(data => (this.customertypes = data))
      .catch(e => {
        // this.$toast.add({
        //   severity: "error",
        //   summary: "Error",
        //   detail: "Error while getting customer types",
        //   life: 5000,
        // })
        this.$store.dispatch("addErrorMessage", {
          severity: "error",
          content: 'Some data was not loaded from "activeCustomerTypes"'
        });
      });

    this.customerService
      .getAllActiveCitiesTowns()
      .then(data => (this.citiesTowns = data))
      .catch(error => {
        this.$store.dispatch("addErrorMessage", {
          severity: "error",
          content: 'Some data was not loaded from "citiesTowns"'
        });
      });
  },
  watch: {
    mbpBranch(val) {
      this.activity.mbpBranch = val;
    },
    user(val) {
      if (val) {
        this.activity.user = val;
        if (val.defBranch) {
          this.activity.mbpBranch = val.defBranch;
        }
      }
    },
    activityType(val) {
      if (
        !this.taskMode &&
        val &&
        val.activityTypeName === "Task" &&
        !(this.activityStatus && this.activityStatus.id)
      ) {
        this.activityStatus = this.activitystatuses.find(
          a => a.statusName === "Task"
        );
      } else {
        if (this.startDate) {
          this.activity.startDate = this.startDate;
        }
        if (this.startTime) {
          this.activity.startTime = this.startTime;
        }
        this.setActivityStatus();
      }

      this.activity.activityType = val;
    },
    postCode(val) {
      this.customer.postCode = val;

      this.customerService
        .getCustomerRegion(val)
        .then(res => {
          if (res[0] && res[0].id) {
            this.customer.region = {
              id: parseInt(res[0].regionCode),
              regionName: res[0].regionName
            };
            if (res[0].salesExec) {
              this.customer.salesExec = res[0].salesExec;
              this.salesExec = res[0].salesExec;
            }
            if (res[0].mbpBranch) {
              this.customer.mbpBranch = res[0].mbpBranch;
              this.branch = res[0].mbpBranch;
            }
          } else {
            throw new Error("Nothing found");
          }
        })
        .catch(err => {
          this.customer.region = {};
          this.branch = {};
          this.customer.mbpBranch = {};
          this.salesExec = {};
          this.customer.salesExec = {};
        });
    },
    cityTown1(val) {
      val && val.id
        ? (this.customer.cityTown = val)
        : (this.customer.cityTown = null);
    },
    cityTown2(val) {
      val && val.id
        ? (this.contact.cityTown = val)
        : (this.contact.cityTown = null);
    },
    customerType(val) {
      val && val.id
        ? (this.customer.customerType = val)
        : (this.customer.customerType = null);
    },
    duplicateDialog(val) {
      this.duplicateDialogKey++;
    },
    reminder(val) {
      if (val && val.value) {
        this.activity.reminder = true;
      } else {
        this.activity.reminder = false;
        this.reminderDate = "";
        this.reminderTime = "";
      }
    },
    deadlineDate(val) {
      this.activity.deadlineDate = val;
    },
    reminderDate() {
      this.analyzineReminderTime();
    },
    reminderTime() {
      this.analyzineReminderTime();
    },
    reminderType(val) {
      this.activity.reminderType = val;
    },
    duration(val) {
      this.activity.duration = val;

      this.useDuration();
    },
    startDate(val) {
      //
      this.activity.startDate = this.startDate;

      this.analyzineStartTime();
    },
    startTime() {
      this.activity.startTime = this.startTime;

      this.analyzineStartTime();
    },
    endDate(val) {
      this.activity.endDate = val;
    },
    activityTimingSection(val) {
      // if (!val && !this.activityToEdit.activityId) {
      //   this.startDate = this.activity.dateCreated
      //   this.endDate = this.activity.dateCreated
      // }
    },
    activityReminderSection(val) {
      if (!val && !this.activityToEdit.activityId) {
        this.deadlineDate = this.activity.dateCreated;
        this.reminderType = this.remindertypes.find(
          a => a.reminderTypeName === "Email"
        );
      }
    },
    quotation(val) {
      this.activity.quote = val;
    },
    selectedCustomer(val) {
      this.requestingQuotations = true;

      this.customerService
        .getCustomerQuotations(val.customerId)
        .then(data => {
          this.quotes = data.map(quote => {
            return {
              ...quote,
              visible: quoteLabel(quote)
            };
          });
          this.quotationSelectionKey++;
          this.requestingQuotations = false;
        })
        .catch(err => {
          this.requestingQuotations = false;

          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while geting customer quotations",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content:
              'Some data was not loaded from "customerquotes/{customerId}"'
          });
        });
    }
  },
  methods: {
    setSelection({ value, index }) {
      this.user = value;
    },
    setCustomerSelection(customer) {
      this.displayDuplicateMessage = false;

      this.contactFormDialog = false;
      this.customerFormDialog = false;
      this.custSearchDialog = true;
      this.loadCustomersAgain++;
      this.preSelectedCustomer = customer;
      this.customer = {};
    },
    checkForDuplicate() {
      if (
        this.customer &&
        this.customer.custName &&
          this.customer.address1 &&
          this.customer.address2 &&
          this.customer.address3 &&
          this.customer.cityTown &&
          this.customer.cityTown.id &&
          this.customer.postCode &&
        (this.lastEnteredName !== this.customer.custName ||
          this.lastEnteredAddress1 !== this.customer.address1 ||
          this.lastEnteredAddress2 !== this.customer.address2 ||
          this.lastEnteredAddress3 !== this.customer.address3 ||
          this.lastEnteredCityTown !== this.customer.cityTown.id ||
          this.lastEnteredPostCode !== this.customer.postCode)
      ) {
        //

        this.lastEnteredName = this.customer.custName;
        this.lastEnteredAddress1 = this.customer.address1;
        this.lastEnteredAddress2 = this.customer.address2;
        this.lastEnteredAddress3 = this.customer.address3;
        this.lastEnteredCityTown = this.customer.cityTown.id;
        this.lastEnteredPostCode = this.customer.postCode;

        this.duplicateChecking = true;
        this.customerService
          .getDupCustomers({
            custName: this.customer.custName,
            address1: this.customer.address1,
            address2: this.customer.address2,
            address3: this.customer.address3,
            cityTown: this.customer.cityTown.id,
            postCode: this.customer.postCode,
            address4: ""
          })
          .then(data => {
            this.duplicateChecking = false;
            //
          })
          .catch(error => {
            //
            this.duplicateChecking = false;
            this.duplicates = [];

            if (error && error.response && error.response.status === 409) {
              this.duplicates = error.response.data;
            } else {
              this.$toast.add({
                severity: "error",
                summary: "Error",
                detail: "Error while checking for duplicate enquiries.",
                life: 5000
              });
            }
          });
      }
    },
    keyMonitor(event) {
      //
      if (event.key === "Tab") {
        let a = document.activeElement;
        if (a) {
          let b = document.getElementsByClassName("p-datepicker p-component");
          b.forEach(c => {
            let found = false; // when moving from date to date (date === time)
            let found1 = true; // when going from date to dropdown (specially in primevue)

            c.parentElement.children.forEach(d => {
              //

              if (d.id === a.id) {
                found = true;
              }
              if (
                d.id &&
                a.parentElement.parentElement.id &&
                d.id !== a.parentElement.parentElement.id
              ) {
                found1 = false;
              }
            });
            //
            if (!found || !found1) {
              c.style.visibility = "hidden";
            }
          });
        }
      }
    },
    analyzineReminderTime() {
      if (this.reminderDate && typeof this.reminderDate !== "string") {
        let year = this.reminderDate.getFullYear(),
          month = this.reminderDate.getMonth(),
          date = this.reminderDate.getDate(),
          hours = 23,
          minutes = 59;
        if (this.reminderTime) {
          (hours = this.reminderTime.getHours()),
            (minutes = this.reminderTime.getMinutes());
        }
        let day = new Date(year, month, date, hours, minutes);

        if (day.getTime() > new Date().getTime()) {
          this.showReminderDateError = false;
          this.activity.reminderDate = this.reminderDate;
          this.activity.reminderTime = this.reminderTime;
          //
        } else {
          this.showReminderDateError = true;
          this.activity.reminderDate = "";
          this.activity.reminderTime = "";
          //
        }
      }
    },
    analyzineStartTime() {
      //
      if (this.startDate && typeof this.startDate !== "string") {
        let year = this.startDate.getFullYear(),
          month = this.startDate.getMonth(),
          date = this.startDate.getDate(),
          hours = 0,
          minutes = 0;
        if (this.startTime) {
          (hours = this.startTime.getHours()),
            (minutes = this.startTime.getMinutes());
        }
        let day = new Date(year, month, date, hours, minutes),
          now = new Date();
        //

        if (day.getTime() > now.getTime()) {
          this.showStartDateError = false;
          this.activity.startDate = this.startDate;
          this.activity.startTime = this.startTime;
        } else {
          this.showStartDateError = true;
        }

        this.setActivityStatus();
        this.useDuration();
      }
    },
    setActivityStatus() {
      // if (this.activityToEdit && this.activityToEdit.activityId) {
      //   this.activityStatus = this.activityToEdit.activityStatus
      // } else {
      if (this.activitystatuses) {
        if (!this.activity.startDate) {
          this.activityStatus = this.activitystatuses.find(
            a => a.statusName === "Task"
          );
        } else {
          //

          // The Activities form keeps a new Task type undated. A task, and a record
          // that already has a start, keeps its When.
          if (
            !this.taskMode &&
            this.activity.activityType &&
            this.activity.activityType.activityTypeName === "Task" &&
            !(this.activityToEdit && this.activityToEdit.startDate)
          ) {
            this.duration = 0;
            this.activity.startDate = "";
            this.activity.startTime = "";
            this.startDate = "";
            this.startTime = "";
          } else {
            if (this.startDate && typeof this.startDate !== "string") {
              let year = this.startDate.getFullYear(),
                month = this.startDate.getMonth(),
                date = this.startDate.getDate(),
                hours = 0,
                minutes = 0;
              if (this.startTime) {
                (hours = this.startTime.getHours()),
                  (minutes = this.startTime.getMinutes());
              }
              let day = new Date(year, month, date, hours, minutes),
                now = new Date();
              //

              if (day.getTime() > now.getTime()) {
                this.activityStatus = this.activitystatuses.find(
                  a => a.statusName === "Upcoming"
                );
              } else {
                this.activityStatus = this.activitystatuses.find(
                  a => a.statusName === "Overdue"
                );
              }
            }
          }
        }
      }
      // }
    },
    addComment(comment) {
      this.sendingRequest = true;

      this.activityService
        .updateActivityStatus(this.activity.activityId, {
          newStatusId: this.tempObj.id,
          resultNotes: comment
        })
        .then(data => {
          this.sendingRequest = false;
          this.commentDialog = false;

          this.$toast.add({
            severity: "success",
            summary: "Success",
            detail: "Status updates.",
            life: 5000
          });

          this.$emit("saved", { activity: this.activity });
        })
        .catch(error => {
          this.sendingRequest = false;
          this.commentDialog = false;

          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error while updating status.",
            life: 5000
          });
        });
    },
    saveScheduleDetails(activity) {
      this.sendingRequest = true;

      this.activityService
        .updateActivityStatus(this.activity.activityId, {
          newStatusId: this.tempObj.id,
          NewStartDate: activity.startDate,
          NewStarTime: activity.startTime,
          NewDuration: activity.duration,
          NewEndDate: activity.endDate,
          NewEndTime: activity.endTime
        })
        .then(data => {
          this.sendingRequest = false;
          this.scheduleDialog = false;

          this.$toast.add({
            severity: "success",
            summary: "Success",
            detail: "Status updates.",
            life: 5000
          });

          this.$emit("saved", { activity: this.activity });
        })
        .catch(error => {
          this.sendingRequest = false;
          this.scheduleDialog = false;

          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error while updating status.",
            life: 5000
          });
        });
    },
    saveMeetingDetails(activity) {
      this.sendingRequest = true;

      // G6: one body for every screen - the result, its notes, and the follow-up when one was asked for
      const obj = completionBody(this.tempObj.id, activity)

      this.activityService
        .updateActivityStatus(this.activity.activityId, obj)
        .then(data => {
          this.sendingRequest = false;
          this.meetingDialog = false;

          this.$toast.add({
            severity: "success",
            summary: "Success",
            detail: "Status updates.",
            life: 5000
          });

          this.$emit("saved", { activity: this.activity });
        })
        .catch(error => {
          this.sendingRequest = false;
          this.meetingDialog = false;

          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error while updating status.",
            life: 5000
          });
        });
    },
    showProgressLostWarning(status) {
      if (this.activity && this.activity.activityId && status && status.id) {
        this.$refs.statuses.hide();

        this.tempStatus = status;
        this.progressLostWarning = true;
      }
    },
    updateStatus(val) {
      if (this.activity && this.activity.activityId && val && val.id) {
        this.progressLostWarning = false;
        this.sendingRequest = false;

        if (this.activity.activityTypeName && this.activity.activityTypeId) {
          this.activity.activityType = {
            activityTypeName: this.activity.activityTypeName,
            activityTypeId: this.activity.activityTypeId
          };
        }

        if (
          opensResultDialog(
            val.statusName,
            this.activity.activityStatus.statusName
          )
        ) {
          this.tempObj = val;
          this.meetingDialog = true;
          this.reloadMeetingDialog++;
        } else if (val.statusName === "Rescheduled") {
          this.tempObj = val;
          this.scheduleDialog = true;
          this.reloadScheduleDialog++;
        } else if (val.statusName === "Cancelled") {
          this.tempObj = val;
          this.commentDialog = true;
          this.reloadCommentBox++;
        } else {
          this.activity.activityStatus = val;
          this.sendingRequest = true;

          this.activityService
            .updateActivityStatus(this.activity.activityId, {
              newStatusId: val.id
            })
            .then(data => {
              this.sendingRequest = false;

              this.$toast.add({
                severity: "success",
                summary: "Success",
                detail: "Status updates.",
                life: 5000
              });

              this.$emit("saved", { activity: this.activity });
            })
            .catch(error => {
              this.sendingRequest = false;

              this.$toast.add({
                severity: "error",
                summary: "Error",
                detail: "Error while updating status.",
                life: 5000
              });
            });
        }
      }
    },
    changeStatus(activity) {
      if (
        !(
          activity.activityStatus.statusName === "Completed" ||
          activity.activityStatus.statusName === "Cancelled"
        ) &&
        this.activitystatuses
      ) {
        this.tempActivityStatuses = nextStatusesFor(activity.activityStatus.statusName, this.activitystatuses, kindOfRecord(activity));

        //

        this.activity = { ...activity };
        this.tempActivityStatus = activity.activityStatus;
        this.tempActivityType = activity.activityType;
        this.$refs.statuses.toggle(event);
      }
    },
    getStyle(data) {
      if (!data) {
        return "";
      } else {
        // https://www.w3schools.com/bootstrap4/tryit.asp?filename=trybs_badges2&stacked=h
        if (data.colourCode) {
          return data.colourCode;
        } else if (
          data.statusName &&
          data.statusName.toLowerCase() === "upcomming"
        ) {
          return "badge-primary";
        } else if (
          data.statusName &&
          data.statusName.toLowerCase() === "task"
        ) {
          return "badge-warning";
        } else if (
          data.statusName &&
          data.statusName.toLowerCase() === "overdue"
        ) {
          return "badge-danger";
        } else if (
          data.statusName &&
          data.statusName.toLowerCase() === "completed"
        ) {
          return "badge-success";
        } else {
          return "badge-dark";
        }
      }
    },
    useDuration() {
      if (
        this.duration &&
        typeof this.duration === "number" &&
        this.activity.startDate &&
        this.activity.startTime
      ) {
        let ms = this.duration * 60000,
          year = this.activity.startDate.getFullYear(),
          month = this.activity.startDate.getMonth(),
          date = this.activity.startDate.getDate(),
          hours = this.activity.startTime.getHours(),
          minutes = this.activity.startTime.getMinutes(),
          startFullTime = new Date(year, month, date, hours, minutes),
          startFullTimeInMS = startFullTime.getTime(),
          endFullTimeInMS = startFullTimeInMS + ms,
          endFullTime = new Date(endFullTimeInMS);

        //

        if (endFullTime) {
          this.activity.endDate = endFullTime;
          this.endDate = endFullTime;
          this.activity.endTime = endFullTime;
        }
      }
    },
    sendDuplicateCustomer() {
      customerConf(this, "ActivityForm.vue");
    },
    getRowSize() {
      if (this.activity && this.activity.notes) {
        let len = this.activity.notes.split("\n");
        return (
          Math.floor(this.activity.notes.length / 100) + len.length
        ).toString();
      } else {
        return "2";
      }
    },
    sendDuplicateContact() {
      this.duplicateDialog = false;

      this.duplicateToSend.customer = this.preSelectedCustomer.customerId;

      this.customerService
        .saveDuplicateContactDB(this.duplicateToSend)
        .then(response => {
          this.preSelectedCustomer = this.customer;
          this.contactFormDialog = false;
          this.customerFormDialog = false;
          this.custSearchDialog = true;

          if (response.status === 200) {
            this.$toast.add({
              severity: "success",
              summary: "New Contact Saved",
              detail: `New contact was saved successfully`,
              life: 5000
            });
          }
        })
        .catch(err => {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error while saving contact",
            life: 5000
          });
        });
    },
    selectCustomerForm() {
      this.customer = {};
      this.postCode = "";
      this.branch = {};
      this.salesExec = {};
      this.customerType = {};
      this.cityTown1 = {};
      this.customerSubmitted = false;
      this.custSearchDialog = false;
      this.contactFormDialog = false;
      this.customerFormDialog = true;

      setTimeout(() => {
        let a = document.getElementById("custName");
        if (a) a.focus();
      }, 100);
    },
    selectContactForm({ customer, contactToEdit }) {
      this.preSelectedCustomer = customer;
      this.customer = customer;

      if (contactToEdit) {
        this.contact = { ...contactToEdit };

        if (contactToEdit.customerId) {
          this.customerService
            .getCustomerInfo(contactToEdit.customerId)
            .then(data => {
              this.contact.customer = data;
              this.customerName = data.custName;
              this.cityTown2 = data.cityTown;
              this.contact.address1 = data.address1;
              this.contact.address2 = data.address2;
              this.contact.address3 = data.address3;
              this.contact.address4 = data.address4;
            })
            .catch(err => {
              // this.$toast.add({
              //   severity: "error",
              //   summary: "Error",
              //   detail: "Error while geting customer info",
              //   life: 5000,
              // })
              this.$store.dispatch("addErrorMessage", {
                severity: "error",
                content:
                  'Some data was not loaded from "customerInfo/{customerId}"'
              });
            });
        }
        if (
          contactToEdit.fullName &&
          !(contactToEdit.firstName && contactToEdit.lastName)
        ) {
          this.contact.firstName = contactToEdit.fullName.split(" ")[0] || "";
          this.contact.lastName = contactToEdit.fullName.split(" ")[1] || "";
        }
      }

      this.custSearchDialog = false;
      this.customerFormDialog = false;
      this.contactFormDialog = true;

      setTimeout(() => {
        let a = document.getElementById("firstName");
        if (a) a.focus();
      }, 100);
    },
    saveCustomer() {
      this.customerSubmitted = true;

      if (!this.duplicateCustCode) {
        this.sendingRequest = true;
        customerLessDataRequest(this, "ActivityForm.vue");
      }
    },
    saveContact() {
      this.contactSubmitted = true;
      this.sendingRequest = true;

      this.contact.customer = this.customer;
      //
      contactRequest(this, "ActivityForm.vue");
    },
    hideAndOpenCustomer() {
      this.preSelectedCustomer = {};
      this.contactFormDialog = false;
      this.customerFormDialog = false;
      this.custSearchDialog = true;
    },
    hideCustomerDialog() {
      this.preSelectedCustomer = {};
      this.contactFormDialog = false;
      this.customerFormDialog = false;
      this.custSearchDialog = true;
    },
    selectedQuotation(quotation) {
      this.quotation = quotation;
      this.quotationSelectionDialog = false;
    },
    hideDialog() {
      this.$emit("close");
    },
    saveAndUpdateStatus() {
      this.activitySubmitted = true;
      // Block submission if contact is not selected and type is Meeting
      if (this.activityType && this.activityType.activityTypeName === 'Meeting' && !this.activity.contact) {
        this.sendingRequest = false;
        return;
      }
      // busy from the first click, so a double click cannot save twice while the warning check is out
      if (this.sendingRequest) return Promise.resolve();
      this.sendingRequest = true;
      return this.confirmFollowupEmails(this.tempStatus).then(ok => {
        if (!ok) { this.sendingRequest = false; return; }
        this.activity.completed = false;
        this.activity.customer = this.selectedCustomer;
        activityRequest(this, "1ActivityForm.vue");
      });
    },
    saveActivity() {
      this.activitySubmitted = true;
      // Block submission if contact is not selected and type is Meeting
      if (this.activityType && this.activityType.activityTypeName === 'Meeting' && !this.activity.contact) {
        this.sendingRequest = false;
        return;
      }
      // busy from the first click, so a double click cannot save twice while the warning check is out
      if (this.sendingRequest) return Promise.resolve();
      this.sendingRequest = true;
      return this.confirmFollowupEmails(this.activity.activityStatus).then(ok => {
        if (!ok) { this.sendingRequest = false; return; }
        this.activity.completed = false;
        this.activity.customer = this.selectedCustomer;
        activityRequest(this, "ActivityForm.vue");
      });
    },
    // Item (a), batch 3: an open task or event about a quote, contact or customer with an automatic email due
    // around its date asks first (Keep / Skip this one / Stop all). A completed or cancelled one does not ask: a
    // logged call or meeting already pauses the emails (item d). Resolves true to save.
    confirmFollowupEmails(status) {
      var name = status && status.statusName;
      var warning = this.$refs.followupDueWarning;
      if (name === "Completed" || name === "Cancelled" || !warning || typeof warning.check !== "function") return Promise.resolve(true);
      return warning.check({
        quote: (this.activity && this.activity.quote) || this.quotation,
        contact: this.activity && this.activity.contact,
        customer: this.selectedCustomer,
        date: this.startDate
      });
    },
    updateCustomer({ customer, contact, contacts }) {
      this.activity = { ...this.activity, customer, contact };
      this.selectedCustomer = customer;
      this.contacts = [...contacts];
      this.custSearchDialog = false;
      if (customer.mbpBranch) {
        this.activity.mbpBranch = customer.mbpBranch;
      }
    },
    setSelection1({ value, index }) {
      //
      this.cityTown1 = value;
      this.checkForDuplicate();
    },
    setSelection2({ value, index }) {
      //
      this.cityTown2 = value;
    }
  }
};
</script>

<style scoped>
.center {
  margin: auto;
  text-align: center;
}
</style>
